/* eslint-disable max-len */

import React, { useState } from 'react';
import styled from 'styled-components';
import { Link } from 'wouter';
import { useObserver } from '../../../CodesThatsGottaGoSomewhereElse';
import { Icon } from '../../../concepts/resources/Icon';
import { Colors, Float, Menu } from '../../../ui';
import { DropButton } from '../../../ui/DropButton';
import { useResolve } from '../../Container';
import { ProfileModel } from '../../ProfileModel';
import { Popover } from '../../canvas/ui/Popover';
import { Avatar } from '../../common/Avatar';
import { usePermissionCheck } from '../../common/PermissionElements';
import { Copy, Flexer } from '../../dashboard/elements/LayoutElements';
import { useIsFreeOrTrial } from '../AccountHooks';
import { AccountModel } from '../AccountModel';

const Frame = styled.div`
    display: flex;
    flex-direction: row;
    max-width: 100%;

    ${DropButton} {
        max-width: 100%;
    }
`;

const AccountInfo = () => {
    const account = useObserver(useResolve(AccountModel));
    return <Flexer flex="row" gap=".75" align="center" maxWidth="100%">
        <Avatar size="2.5"
            name={account.label}
            variant="roundish"
            color={account.imageUrl ? 'transparent' : Colors.primaryDark}
            photo={account.imageUrl}
        />
        <Copy flush size="1.125" bold truncate style={{ letterSpacing: '-0.025rem' }}>
            {account.label}
        </Copy>
        <Flexer flex center padding=".25">
            <Icon size="1" src="deqo://icons/hero/chevron-down" />
        </Flexer>
    </Flexer>;
};

const SwitchMenu = () => {
    const account = useObserver(useResolve(AccountModel));
    const profile = useObserver(useResolve(ProfileModel));
    return <Menu>
        {profile.accounts.map(x =>
            <a key={x.id} href={`/${x.id}`}>
                <Menu.Item>
                    <Menu.ItemText>{x.label}</Menu.ItemText>
                    {x.id === account.id && <Menu.Badge color={Colors.positive}>Active</Menu.Badge>}
                </Menu.Item>
            </a>
        )}
    </Menu>;
};

const AccountMenu = () => {

    const account = useObserver(useResolve(AccountModel));
    const profile = useObserver(useResolve(ProfileModel));
    const canSwitch = profile.accounts.length > 1;

    const isFreeOrTrial = useIsFreeOrTrial();
    const canAdmin = usePermissionCheck('ac_team:read');
    const canBilling = usePermissionCheck('ac_billing:read');

    return <Float shadow="lg" inline>
        <Flexer minWidth="14">
            <Menu>
                <Menu.Section first>
                    {canAdmin && <Link to="~/manage">
                        <Menu.Item>
                            <Menu.ItemText>Manage Organization</Menu.ItemText>
                        </Menu.Item>
                    </Link>}
                    {!isFreeOrTrial && canBilling &&
                        <a href="/billing" target="_blank">
                            <Menu.Item>
                                <Menu.ItemText>Manage Billing</Menu.ItemText>
                            </Menu.Item>
                        </a>
                    }
                    {isFreeOrTrial &&
                        <a href={`/pricing?accountId=${account.id}`}>
                            <Menu.Item>
                                <Menu.ItemText>Upgrade</Menu.ItemText>
                            </Menu.Item>
                        </a>
                    }
                    <a href={`/leave/${account.id}`}>
                        <Menu.Item >
                            <Menu.ItemText>
                                Leave {account.label}
                            </Menu.ItemText>
                        </Menu.Item>
                    </a>
                </Menu.Section>
                {canSwitch &&
                    <Menu.Section>
                        <Menu.SubMenuItem content={<SwitchMenu />}>
                            <Menu.ItemText>
                                Switch Organization
                            </Menu.ItemText>
                            <Menu.SubMenuIndicator />
                        </Menu.SubMenuItem>
                    </Menu.Section>
                }
            </Menu>
        </Flexer>
    </Float>;
};

export const AccountBlock = () => {
    const [open, setOpen] = useState(false);

    return <Popover
        open={open}
        onOpenChange={setOpen}
        placement="top-end"
        inner={{ direction: 'down', offset: '.5' }}
        content={<AccountMenu />}
    >
        <DropButton active={open} rounding=".75" overflow=".375">
            <AccountInfo />
        </DropButton>
    </Popover>;
};
